module.exports = __webpack_public_path__ + "img/heart.b0b23ee.svg";